import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { useEffect, useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import {
  convertCurrencyFormat,
  formatToStandardDate,
} from "../../helper/common";
const IncomeSourceCard = ({
  userId,
  amount,
  type,
  selectedSource = [],
  changeSelectedSource,
}) => {
  const { _t } = useTranslator();
  const [isActive, setIsActive] = useState(selectedSource?.includes(type));

  useEffect(() => {
    setIsActive(selectedSource?.includes(type));
  }, [selectedSource]);

  const handleChange = () => {
    changeSelectedSource(userId, type);
  };

  const isMonthlyIncome =
    type.startsWith("payslip:") || type === "declaredIncome";

  return (
    <div
      className={`income-source-card-wrapper ${
        isActive ? "income-source-card-wrapper-active" : ""
      }`}
      onClick={handleChange}
    >
      <div className="d-flex align-items-center about-source">
        <div className="default-checkbox d-flex align-items-center justify-content-center">
          {isActive && <CheckOutlinedIcon />}
        </div>
        <div className="d-flex flex-column flex-1 w-100">
          <div className="d-flex justify-content-between flex-1 align-items-center">
            <h4>
              {type.startsWith("payslip:")
                ? (() => {
                    const [, rawDate, employer] = type.split(":");
                    const formattedDate = formatToStandardDate(rawDate?.trim());
                    return employer?.trim()
                      ? `${_t("payslip")} – ${employer.trim()} (${formattedDate})`
                      : `${_t("payslip")} (${formattedDate})`;
                  })()
                : _t(type)}{" "}
            </h4>
            <span
              className={`monthly-badge ${!isMonthlyIncome ? "annual-badge" : ""}`}
            >
              {isMonthlyIncome
                ? `${_t("monthly")}`
                : `${_t("annualInPayslip")}`}
            </span>
          </div>
          <h6>
            {/* {!isMonthlyIncome ? <span>{`${_t("annual")} • `}</span> : null} */}
            {convertCurrencyFormat(amount)}€
            {!isMonthlyIncome &&
              ` -> ` +
                convertCurrencyFormat(Math.round(amount / 12)) +
                "€/" +
                _t("mo")}
          </h6>
        </div>
      </div>
    </div>
  );
};

export default IncomeSourceCard;
